import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-triangle-down",
  "use": "chevron-triangle-down-usage",
  "viewBox": "0 0 18 10",
  "content": "<symbol viewBox=\"0 0 18 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevron-triangle-down\">\n<path d=\"M17 1.5L9.70711 8.79289C9.31658 9.18342 8.68342 9.18342 8.29289 8.79289L1 1.5\" stroke=\"#724AE6\" stroke-width=\"1.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol